import { isDefined } from "@clipboard-health/util-ts";

import { type ExternalAccount, type PayoutSchedule } from "../api/schema";

/**
 * Resolve the preferred external account stripe id based on the payout schedule and the external accounts.
 * @param props - The props object containing the preferred external account stripe id, payout schedule, and external accounts.
 * @returns The preferred external account stripe id.
 */
export function resolvePreferredExternalAccount(props: {
  preferredExternalAccountStripeId: ExternalAccount["stripeId"] | undefined;
  payoutSchedule: PayoutSchedule;
  externalAccounts: ExternalAccount[];
}) {
  const { preferredExternalAccountStripeId, payoutSchedule, externalAccounts } = props;

  // Pick preferred account if it is not deleted
  if (
    isDefined(preferredExternalAccountStripeId) &&
    externalAccounts.some(
      (externalAccount) => externalAccount.stripeId === preferredExternalAccountStripeId
    )
  ) {
    return preferredExternalAccountStripeId;
  }

  // Otherwise use the first compatible account
  return payoutSchedule === "instant"
    ? externalAccounts.find((externalAccount) => externalAccount.supportsInstantPayouts)?.stripeId
    : externalAccounts[0]?.stripeId;
}
